module.exports = __webpack_public_path__ + "static/media/galerija_2021 (7)-min.4cb76435.jpg";